import { render } from "./Account.vue?vue&type=template&id=aa395992&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=aa395992&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-aa395992"

export default script